import { useParams } from "react-router-dom"

import { PointSelectListener } from "@l2r-front/l2r-common"
import { BASE_MAP_ID } from "@l2r-front/l2r-map"

import { useEquipment } from "../../hooks/queries/equipment/useEquipments"

export function EquipmentSelectListener() {

    const { signId: equipmentId } = useParams()
    const { data: signFeature } = useEquipment(equipmentId, { as_geojson: true })

    return <PointSelectListener mapId={BASE_MAP_ID} pointFeature={signFeature} />
}
